module.exports = "<div class=\"wrapper wrapper-content\" id=basic-info> <div class=row> <div class=col-lg-9> <div class=ibox> <div class=ibox-title> <h5>Outline your specific use case below</h5> </div> <div class=ibox-content> Mark the importance of each item on a scale from 1-5: [ODI-Survey] </div> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/1-owner/what-to-get-done.html
// module id = 630
// module chunks = 86